import { createSolidIcon } from "./iconCore"

import AlertCircleSolidSvg from "./icons/alert-circle-solid.svg"
import AlertOctagonSolidSvg from "./icons/alert-octagon-solid.svg"
import AlertTriangleSolidSvg from "./icons/alert-triangle-solid.svg"
import AnnouncementSolidSvg from "./icons/announcement-solid.svg"
import ArrowCircleDownSolidSvg from "./icons/arrow-circle-down-solid.svg"
import ArrowCircleLeftSolidSvg from "./icons/arrow-circle-left-solid.svg"
import ArrowCircleRightSolidSvg from "./icons/arrow-circle-right-solid.svg"
import ArrowCircleUpSolidSvg from "./icons/arrow-circle-up-solid.svg"
import AudienceSolidSvg from "./icons/audience-solid.svg"
import BeakerSolidSvg from "./icons/beaker-solid.svg"
import BellOffSolidSvg from "./icons/bell-off-solid.svg"
import BellSolidSvg from "./icons/bell-solid.svg"
import BugSolidSvg from "./icons/bug-solid.svg"
import CalendarSolidSvg from "./icons/calendar-solid.svg"
import CameraOffSolidSvg from "./icons/camera-off-solid.svg"
import CameraReverseSolidSvg from "./icons/camera-reverse-solid.svg"
import CameraSolidSvg from "./icons/camera-solid.svg"
import CardSolidSvg from "./icons/card-solid.svg"
import ChartSolidSvg from "./icons/chart-solid.svg"
import ChatOffSolidSvg from "./icons/chat-off-solid.svg"
import ChatSolidSvg from "./icons/chat-solid.svg"
import CheckVerifiedSolidSvg from "./icons/check-verified-solid.svg"
import CheckCircleSolidSvg from "./icons/check-circle-solid.svg"
import ChevronCircleDownSolidSvg from "./icons/chevron-circle-down-solid.svg"
import ChevronCircleLeftSolidSvg from "./icons/chevron-circle-left-solid.svg"
import ChevronCircleRightSolidSvg from "./icons/chevron-circle-right-solid.svg"
import ChevronCircleUpSolidSvg from "./icons/chevron-circle-up-solid.svg"
import ClapperboardSolidSvg from "./icons/clapperboard-solid.svg"
import ClipboardCheckSolidSvg from "./icons/clipboard-check-solid.svg"
import ClipboardSolidSvg from "./icons/clipboard-solid.svg"
import ClockSolidSvg from "./icons/clock-solid.svg"
import CloseCircleSolidSvg from "./icons/close-circle-solid.svg"
import ClosedCaptionSolidSvg from "./icons/closed-caption-solid.svg"
import CopySolidSvg from "./icons/copy-solid.svg"
import CrownSolidSvg from "./icons/crown-solid.svg"
import DashboardSolidSvg from "./icons/dashboard-solid.svg"
import DiscountSolidSvg from "./icons/discount-solid.svg"
import DiceSolidSvg from "./icons/dice-solid.svg"
import EditSolidSvg from "./icons/edit-solid.svg"
import EyeOffSolidSvg from "./icons/eye-off-solid.svg"
import EyeSolidSvg from "./icons/eye-solid.svg"
import FaceHappySolidSvg from "./icons/face-happy-solid.svg"
import FaceSmileSolidSvg from "./icons/face-smile-solid.svg"
import FilmSolidSvg from "./icons/film-solid.svg"
import FireSolidSvg from "./icons/fire-solid.svg"
import FlagSolidSvg from "./icons/flag-solid.svg"
import FlashOffSolidSvg from "./icons/flash-off-solid.svg"
import FlashSolidSvg from "./icons/flash-solid.svg"
import GiftSolidSvg from "./icons/gift-solid.svg"
import GraduationHatSolidSvg from "./icons/graduation-hat-solid.svg"
import HeartHandSolidSvg from "./icons/heart-hand-solid.svg"
import HeartSolidSvg from "./icons/heart-solid.svg"
import HeartsSolidSvg from "./icons/hearts-solid.svg"
import HelpCircleSolidSvg from "./icons/help-circle-solid.svg"
import HomeSolidSvg from "./icons/home-solid.svg"
import HourglassSolidSvg from "./icons/hourglass-solid.svg"
import ImageFullSolidSvg from "./icons/image-full-solid.svg"
import ImageSmallSolidSvg from "./icons/image-small-solid.svg"
import ImageSolidSvg from "./icons/image-solid.svg"
import InfoCircleSolidSvg from "./icons/info-circle-solid.svg"
import LibrarySolidSvg from "./icons/library.svg"
import LifeBuoySolidSvg from "./icons/life-buoy-solid.svg"
import LiveSolidSvg from "./icons/live-solid.svg"
import LockUnlockedSolidSvg from "./icons/lock-unlocked-solid.svg"
import LockSolidSvg from "./icons/lock-solid.svg"
import MailOpenSolidSvg from "./icons/mail-open-solid.svg"
import MailSolidSvg from "./icons/mail-solid.svg"
import MicrophoneOffSolidSvg from "./icons/microphone-off-solid.svg"
import MicrophoneOnSolidSvg from "./icons/microphone-on-solid.svg"
import MinusCircleSolidSvg from "./icons/minus-circle-solid.svg"
import ModeratorSolidSvg from "./icons/moderator-solid.svg"
import NoPermissionSolidSvg from "./icons/no-permission-solid.svg"
import PackagePlusSolidSvg from "./icons/package-plus-solid.svg"
import PackageSearchSolidSvg from "./icons/package-search-solid.svg"
import PackageSolidSvg from "./icons/package-solid.svg"
import PaletteSolidSvg from "./icons/palette-solid.svg"
import PauseSolidSvg from "./icons/pause-solid.svg"
import PlayCircleSolidSvg from "./icons/play-circle-solid.svg"
import PlaySolidSvg from "./icons/play-solid.svg"
import PlugSolidSvg from "./icons/plug-solid.svg"
import PlusCircleSolidSvg from "./icons/plus-circle-solid.svg"
import ProducerSolidSvg from "./icons/producer-solid.svg"
import PublishSolidSvg from "./icons/publish-solid.svg"
import SaleTagSolidSvg from "./icons/sale-tag-solid.svg"
import ScreenShareSolidSvg from "./icons/screen-share-solid.svg"
import SendSolidSvg from "./icons/send-solid.svg"
import SettingsSolidSvg from "./icons/settings-solid.svg"
import ShareSolidSvg from "./icons/share-solid.svg"
import ShoppingBagSolidSvg from "./icons/shopping-bag-solid.svg"
import ShoppingCartSolidSvg from "./icons/shopping-cart-solid.svg"
import StackSolidSvg from "./icons/stack-solid.svg"
import StarsSolidSvg from "./icons/stars-solid.svg"
import StopCircleSolidSvg from "./icons/stop-circle-solid.svg"
import StopSolidSvg from "./icons/stop-solid.svg"
import StudioSolidSvg from "./icons/studio-solid.svg"
import ThumbsUpSolidSvg from "./icons/thumbs-up-solid.svg"
import TrashSolidSvg from "./icons/trash-solid.svg"
import UserCheckSolidSvg from "./icons/user-check-solid.svg"
import UserCircleSolidSvg from "./icons/user-circle-solid.svg"
import UserSolidSvg from "./icons/user-solid.svg"
import UserXSolidSvg from "./icons/user-x-solid.svg"
import UsersSolidSvg from "./icons/users-solid.svg"
import VideoOffSolidSvg from "./icons/video-off-solid.svg"
import VideoSolidSvg from "./icons/video-solid.svg"
import ViewerSolidSvg from "./icons/viewer-solid.svg"
import VolumeOffSolidSvg from "./icons/volume-off-solid.svg"
import VolumeOnSolidSvg from "./icons/volume-on-solid.svg"

export const AlertCircleSolid = createSolidIcon(AlertCircleSolidSvg, "Alert")
export const AlertOctagonSolid = createSolidIcon(AlertOctagonSolidSvg, "Alert")
export const AlertTriangleSolid = createSolidIcon(
  AlertTriangleSolidSvg,
  "Alert",
)
export const AnnouncementSolid = createSolidIcon(
  AnnouncementSolidSvg,
  "Announcement",
)
export const ArrowCircleDownSolid = createSolidIcon(
  ArrowCircleDownSolidSvg,
  "Arrow Down",
)
export const ArrowCircleLeftSolid = createSolidIcon(
  ArrowCircleLeftSolidSvg,
  "Arrow Left",
)
export const ArrowCircleRightSolid = createSolidIcon(
  ArrowCircleRightSolidSvg,
  "Arrow Right",
)
export const ArrowCircleUpSolid = createSolidIcon(
  ArrowCircleUpSolidSvg,
  "Arrow Up",
)
export const AudienceSolid = createSolidIcon(AudienceSolidSvg, "Audience")
export const BeakerSolid = createSolidIcon(BeakerSolidSvg, "Beaker")
export const BellOffSolid = createSolidIcon(BellOffSolidSvg, "Bell Off")
export const BellSolid = createSolidIcon(BellSolidSvg, "Bell")
export const BugSolid = createSolidIcon(BugSolidSvg, "Bug")
export const CalendarSolid = createSolidIcon(CalendarSolidSvg, "Calendar")
export const CameraOffSolid = createSolidIcon(CameraOffSolidSvg, "Camera Off")
export const CameraReverseSolid = createSolidIcon(
  CameraReverseSolidSvg,
  "Camera Reverse",
)
export const CameraSolid = createSolidIcon(CameraSolidSvg, "Chat")
export const CardSolid = createSolidIcon(CardSolidSvg, "Card")
export const ChartSolid = createSolidIcon(ChartSolidSvg, "Chart")
export const ChatOffSolid = createSolidIcon(ChatOffSolidSvg, "Chat Off")
export const ChatSolid = createSolidIcon(ChatSolidSvg, "Chat")
export const CheckCircleSolid = createSolidIcon(CheckCircleSolidSvg, "Check")
export const CheckVerifiedSolid = createSolidIcon(
  CheckVerifiedSolidSvg,
  "Verified",
)
export const ChevronCircleDownSolid = createSolidIcon(
  ChevronCircleDownSolidSvg,
  "Chevron Down",
)
export const ChevronCircleLeftSolid = createSolidIcon(
  ChevronCircleLeftSolidSvg,
  "Chevron Left",
)
export const ChevronCircleRightSolid = createSolidIcon(
  ChevronCircleRightSolidSvg,
  "Chevron Right",
)
export const ChevronCircleUpSolid = createSolidIcon(
  ChevronCircleUpSolidSvg,
  "Chevron Up",
)
export const ClapperboardSolid = createSolidIcon(
  ClapperboardSolidSvg,
  "Clapperboard",
)
export const ClipboardSolid = createSolidIcon(ClipboardSolidSvg, "Clipboard")
export const ClipboardCheckSolid = createSolidIcon(
  ClipboardCheckSolidSvg,
  "Clipboard Check",
)
export const ClockSolid = createSolidIcon(ClockSolidSvg, "Clock")
export const CloseCircleSolid = createSolidIcon(CloseCircleSolidSvg, "Close")
export const ClosedCaptionSolid = createSolidIcon(
  ClosedCaptionSolidSvg,
  "Closed Captions",
)
export const CopySolid = createSolidIcon(CopySolidSvg, "Copy")
export const CrownSolid = createSolidIcon(CrownSolidSvg, "Crown")
export const DashboardSolid = createSolidIcon(DashboardSolidSvg, "Dashboard")
export const DiceSolid = createSolidIcon(DiceSolidSvg, "Dice")
export const DiscountSolid = createSolidIcon(DiscountSolidSvg, "Discount")
export const EditSolid = createSolidIcon(EditSolidSvg, "Edit")
export const EyeOffSolid = createSolidIcon(EyeOffSolidSvg, "Eye Off")
export const EyeSolid = createSolidIcon(EyeSolidSvg, "Eye")
export const FaceHappySolid = createSolidIcon(FaceHappySolidSvg, "Happy Face")
export const FaceSmileSolid = createSolidIcon(FaceSmileSolidSvg, "Smiling Face")
export const FilmSolid = createSolidIcon(FilmSolidSvg, "Film")
export const FireSolid = createSolidIcon(FireSolidSvg, "Fire")
export const FlagSolid = createSolidIcon(FlagSolidSvg, "Flag")
export const FlashOffSolid = createSolidIcon(FlashOffSolidSvg, "Flash Off")
export const FlashSolid = createSolidIcon(FlashSolidSvg, "Flash")
export const GiftSolid = createSolidIcon(GiftSolidSvg, "Gift")
export const GraduationHatSolid = createSolidIcon(
  GraduationHatSolidSvg,
  "Graduation Hat",
)
export const HeartHandSolid = createSolidIcon(HeartHandSolidSvg, "Heart Hand")
export const HeartSolid = createSolidIcon(HeartSolidSvg, "Heart")
export const HeartsSolid = createSolidIcon(HeartsSolidSvg, "Hearts")
export const HelpCircleSolid = createSolidIcon(HelpCircleSolidSvg, "Help")
export const HomeSolid = createSolidIcon(HomeSolidSvg, "Home")
export const HourglassSolid = createSolidIcon(HourglassSolidSvg, "Hourglass")
export const ImageFullSolid = createSolidIcon(ImageFullSolidSvg, "Image Full")
export const ImageSmallSolid = createSolidIcon(
  ImageSmallSolidSvg,
  "Image Small",
)
export const ImageSolid = createSolidIcon(ImageSolidSvg, "Image")
export const InfoCircleSolid = createSolidIcon(InfoCircleSolidSvg, "Info")
export const LibrarySolid = createSolidIcon(LibrarySolidSvg, "Library")
export const LifeBuoySolid = createSolidIcon(LifeBuoySolidSvg, "Life Buoy")
export const LiveSolid = createSolidIcon(LiveSolidSvg, "Live")
export const LockUnlockedSolid = createSolidIcon(
  LockUnlockedSolidSvg,
  "Unlocked",
)
export const LockSolid = createSolidIcon(LockSolidSvg, "Lock")
export const MailOpenSolid = createSolidIcon(MailOpenSolidSvg, "Mail Open")
export const MailSolid = createSolidIcon(MailSolidSvg, "Mail")
export const MicrophoneOffSolid = createSolidIcon(
  MicrophoneOffSolidSvg,
  "Microphone Off",
)
export const MicrophoneOnSolid = createSolidIcon(
  MicrophoneOnSolidSvg,
  "Microphone On",
)
export const MinusCircleSolid = createSolidIcon(MinusCircleSolidSvg, "Minus")
export const ModeratorSolid = createSolidIcon(ModeratorSolidSvg, "Moderator")
export const NoPermissionSolid = createSolidIcon(
  NoPermissionSolidSvg,
  "No Permission",
)
export const PackagePlusSolid = createSolidIcon(
  PackagePlusSolidSvg,
  "Add Package",
)
export const PackageSearchSolid = createSolidIcon(
  PackageSearchSolidSvg,
  "Package Search",
)
export const PackageSolid = createSolidIcon(PackageSolidSvg, "Package")
export const PaletteSolid = createSolidIcon(PaletteSolidSvg, "Palette")
export const PauseSolid = createSolidIcon(PauseSolidSvg, "Pause")
export const PlayCircleSolid = createSolidIcon(PlayCircleSolidSvg, "Play")
export const PlaySolid = createSolidIcon(PlaySolidSvg, "Play")
export const PlugSolid = createSolidIcon(PlugSolidSvg, "Plug")
export const PlusCircleSolid = createSolidIcon(PlusCircleSolidSvg, "Plus")
export const ProducerSolid = createSolidIcon(ProducerSolidSvg, "Producer")
export const PublishSolid = createSolidIcon(PublishSolidSvg, "Publish")
export const SaleTagSolid = createSolidIcon(SaleTagSolidSvg, "Sale Tag")
export const ScreenShareSolid = createSolidIcon(
  ScreenShareSolidSvg,
  "Screen Share",
)
export const SendSolid = createSolidIcon(SendSolidSvg, "Send")
export const SettingsSolid = createSolidIcon(SettingsSolidSvg, "Settings")
export const ShareSolid = createSolidIcon(ShareSolidSvg, "Share")
export const ShoppingBagSolid = createSolidIcon(
  ShoppingBagSolidSvg,
  "Shopping Bag",
)
export const ShoppingCartSolid = createSolidIcon(
  ShoppingCartSolidSvg,
  "Shopping Cart",
)
export const StackSolid = createSolidIcon(StackSolidSvg, "")
export const StarsSolid = createSolidIcon(StarsSolidSvg, "Stars")
export const StopCircleSolid = createSolidIcon(StopCircleSolidSvg, "Stop")
export const StopSolid = createSolidIcon(StopSolidSvg, "Stop")
export const StudioSolid = createSolidIcon(StudioSolidSvg, "Studio")
export const ThumbsUpSolid = createSolidIcon(ThumbsUpSolidSvg, "Thumbs Up")
export const TrashSolid = createSolidIcon(TrashSolidSvg, "Trash")
export const UserCheckSolid = createSolidIcon(UserCheckSolidSvg, "User Check")
export const UserCircleSolid = createSolidIcon(UserCircleSolidSvg, "User")
export const UserSolid = createSolidIcon(UserSolidSvg, "User")
export const UserXSolid = createSolidIcon(UserXSolidSvg, "Delete User")
export const UsersSolid = createSolidIcon(UsersSolidSvg, "Users")
export const VideoOffSolid = createSolidIcon(VideoOffSolidSvg, "Video Off")
export const VideoSolid = createSolidIcon(VideoSolidSvg, "Video")
export const ViewerSolid = createSolidIcon(ViewerSolidSvg, "Viewer")
export const VolumeOffSolid = createSolidIcon(VolumeOffSolidSvg, "Volume Off")
export const VolumeOnSolid = createSolidIcon(VolumeOnSolidSvg, "Volume On")
